(function () {
  'use strict';
  if (window.gsThemeIntegrityLoaded) return;
  window.gsThemeIntegrityLoaded = true;

  function installCatalog() {
    if (!window.theme || !theme.AjaxRenderer) return;
    var prototype = theme.AjaxRenderer.prototype;
    if (prototype.gsParamsPatched) return;
    prototype.gsParamsPatched = true;
    prototype.getUpdatedParams = function (currentParams, newParams) {
      var result = new URLSearchParams();
      var preserved = ['sort_by', 'q', 'options[prefix]', 'type'];
      preserved.forEach(function (key) {
        if (!newParams.has(key)) currentParams.getAll(key).forEach(function (value) { result.append(key, value); });
      });
      newParams.forEach(function (value, key) {
        if (value !== '' && !result.getAll(key).includes(value)) result.append(key, value);
      });
      return result;
    };
  }

  function visibleOptions(instance) {
    return Array.from(instance.predictiveSearchResults.querySelectorAll('[role="option"]'))
      .filter(function (option) { return option.getClientRects().length && getComputedStyle(option).visibility !== 'hidden'; });
  }

  function selectOption(instance, option) {
    instance.predictiveSearchResults.querySelectorAll('[aria-selected="true"]').forEach(function (item) {
      item.setAttribute('aria-selected', 'false');
    });
    instance.input.removeAttribute('aria-activedescendant');
    if (!option) return;
    option.setAttribute('aria-selected', 'true');
    instance.input.setAttribute('aria-activedescendant', option.id);
    option.scrollIntoView({block: 'nearest'});
  }

  function invalidate(instance) {
    instance.gsRequestVersion = (instance.gsRequestVersion || 0) + 1;
    if (instance.gsController) instance.gsController.abort();
    instance.gsController = null;
    clearTimeout(instance.gsTimeout);
    instance.predictiveSearchResults.removeAttribute('aria-busy');
  }

  function prepare(instance) {
    if (instance.gsPrepared || !instance.dataset.gsSearchId || !instance.input || !instance.predictiveSearchResults) return;
    instance.gsPrepared = true;
    var results = instance.predictiveSearchResults;
    results.id = instance.dataset.gsSearchId + '-results';
    results.setAttribute('role', 'listbox');
    results.setAttribute('aria-label', instance.input.getAttribute('placeholder') || instance.input.name);
    instance.input.setAttribute('aria-controls', results.id);
    instance.input.removeAttribute('aria-owns');
    instance.input.addEventListener('input', function () {
      instance.gsRequestAllowed = true;
      invalidate(instance);
      instance.input.removeAttribute('aria-activedescendant');
      instance.input.setAttribute('aria-expanded', 'false');
      results.style.display = 'none';
      results.innerHTML = '';
      if (!instance.input.value.trim()) instance.close();
    });
    instance.input.addEventListener('keydown', function (event) {
      if (event.isComposing) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        instance.close();
        return;
      }
      if (instance.input.getAttribute('aria-expanded') !== 'true') return;
      var options = visibleOptions(instance);
      var active = options.findIndex(function (item) { return item.id === instance.input.getAttribute('aria-activedescendant'); });
      if ((event.key === 'ArrowDown' || event.key === 'ArrowUp') && options.length) {
        event.preventDefault();
        var next = event.key === 'ArrowDown' ? (active + 1) % options.length : (active < 0 ? options.length - 1 : (active - 1 + options.length) % options.length);
        selectOption(instance, options[next]);
      } else if (event.key === 'Enter' && active >= 0) {
        event.preventDefault();
        var option = options[active];
        var target = option.matches('a,button') ? option : option.querySelector('a,button');
        if (target) target.click();
      }
    });
    instance.addEventListener('focusout', function () {
      setTimeout(function () { if (!instance.contains(document.activeElement)) instance.close(); }, 0);
    });
  }

  function decorateResults(instance) {
    var root = instance.predictiveSearchResults;
    var prefix = root.id;
    var idMap = {};
    root.querySelectorAll('[id]').forEach(function (element, index) {
      var oldId = element.id;
      element.id = prefix + '-node-' + index;
      idMap[oldId] = element.id;
    });
    root.querySelectorAll('[aria-labelledby]').forEach(function (element) {
      var names = element.getAttribute('aria-labelledby').split(/\s+/).map(function (id) { return idMap[id] || id; });
      element.setAttribute('aria-labelledby', names.join(' '));
    });
    root.querySelectorAll('ul[role="listbox"]').forEach(function (element) { element.setAttribute('role', 'group'); });
    root.querySelectorAll('.results__search-btn,.predictive-search__no-results').forEach(function (element) { element.setAttribute('role', 'option'); });
    root.querySelectorAll('[role="option"]').forEach(function (element, index) {
      element.id = prefix + '-option-' + index;
      element.setAttribute('aria-selected', 'false');
    });
    var status = instance.querySelector('[data-gs-search-status]');
    var label = root.querySelector('[data-gs-results-label]');
    if (status) status.textContent = label ? label.dataset.gsResultsLabel : '';
  }

  function installSearch(Search) {
    var prototype = Search.prototype;
    if (prototype.gsIntegrityPatched) return;
    prototype.gsIntegrityPatched = true;
    var original = {getSearchResults: prototype.getSearchResults, onChange: prototype.onChange, open: prototype.open, close: prototype.close};
    prototype.onChange = function () {
      if (!this.dataset.gsSearchId) return original.onChange.call(this);
      prepare(this);
      if (this.gsRequestAllowed === false) return;
      var term = this.input.value.trim();
      if (!term) { this.close(); return; }
      this.getSearchResults(term);
    };
    prototype.getSearchResults = function (term) {
      if (!this.dataset.gsSearchId) return original.getSearchResults.call(this, term);
      prepare(this);
      invalidate(this);
      var instance = this;
      var version = this.gsRequestVersion;
      this.gsController = new AbortController();
      var signal = this.gsController.signal;
      this.gsTimeout = setTimeout(function () { if (version === instance.gsRequestVersion) instance.close(); }, 8000);
      this.predictiveSearchResults.setAttribute('aria-busy', 'true');
      var url = new URL(theme.routes.predictiveSearch, window.location.href);
      url.searchParams.set('q', term);
      url.searchParams.set('resources[limit]', '3');
      url.searchParams.set('resources[limit_scope]', 'each');
      url.searchParams.set('section_id', 'search-results');
      return fetch(url.toString(), {signal: signal}).then(function (response) {
        if (!response.ok) throw new Error('Predictive search HTTP ' + response.status);
        return response.text();
      }).then(function (text) {
        if (version !== instance.gsRequestVersion || instance.input.value.trim() !== term || !instance.isConnected) return;
        var section = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-search-results');
        if (!section) throw new Error('Missing predictive search section');
        instance.predictiveSearchResults.innerHTML = section.innerHTML;
        decorateResults(instance);
        instance.open();
        if (window.AOS && typeof AOS.refreshHard === 'function') AOS.refreshHard();
      }).catch(function (error) {
        if (version !== instance.gsRequestVersion || error.name === 'AbortError') return;
        instance.close();
      }).finally(function () {
        if (version === instance.gsRequestVersion) {
          clearTimeout(instance.gsTimeout);
          instance.predictiveSearchResults.removeAttribute('aria-busy');
        }
      });
    };
    prototype.open = function () {
      if (!this.dataset.gsSearchId) return original.open.call(this);
      prepare(this);
      this.predictiveSearchResults.style.display = 'block';
      this.classList.add('is-active');
      this.input.setAttribute('aria-expanded', 'true');
    };
    prototype.close = function () {
      if (!this.dataset.gsSearchId || !this.predictiveSearchResults) return original.close.call(this);
      prepare(this);
      var wasActive = this.classList.contains('is-active');
      this.gsRequestAllowed = false;
      invalidate(this);
      this.predictiveSearchResults.style.display = 'none';
      this.predictiveSearchResults.innerHTML = '';
      this.classList.remove('is-active');
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-activedescendant');
      var status = this.querySelector('[data-gs-search-status]');
      if (status) status.textContent = '';
      if (!document.querySelector('predictive-search.is-active')) {
        document.body.classList.remove('predictive-overflow-hidden');
        if (wasActive) document.dispatchEvent(new CustomEvent('predictive-search:close-all'));
      }
    };
    function prepareAll() { document.querySelectorAll('predictive-search[data-gs-search-id]').forEach(prepare); }
    prepareAll();
    document.addEventListener('shopify:section:load', prepareAll);
  }

  installCatalog();
  document.addEventListener('page:loaded', installCatalog, {once:true});
  if (window.customElements) customElements.whenDefined('predictive-search').then(installSearch);
})();
